var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.723,18.313l-2.953-2.953c.892-1.184,1.427-2.651,1.427-4.244,0-3.904-3.176-7.08-7.08-7.08s-7.08,3.176-7.08,7.08,3.176,7.08,7.08,7.08c1.59,0,3.055-.534,4.238-1.422l2.954,2.954c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023,0-1.414ZM6.037,11.116c0-2.801,2.279-5.08,5.08-5.08s5.08,2.279,5.08,5.08-2.279,5.08-5.08,5.08-5.08-2.279-5.08-5.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapSearch);
export default __webpack_public_path__ + "static/media/map-search.fb480009da0b3863313ed112c61a44f9.svg";
export { ForwardRef as ReactComponent };